import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Materials API
export const materialsApi = {
  getAll: (category) => api.get('/materials', { params: { category } }),
  create: (data) => api.post('/materials', data),
  update: (id, data) => api.put(`/materials/${id}`, data),
  delete: (id) => api.delete(`/materials/${id}`),
  analyzeUrl: (url) => api.post('/materials/analyze-url', { url }),
};

// Goals API
export const goalsApi = {
  getAll: () => api.get('/goals'),
  getById: (id) => api.get(`/goals/${id}`),
  create: (data) => api.post('/goals', data),
  update: (id, data) => api.put(`/goals/${id}`, data),
  updateProgress: (id, progress) => api.patch(`/goals/${id}/progress`, { progress }),
  delete: (id) => api.delete(`/goals/${id}`),
};

// Todos API
export const todosApi = {
  getByGoal: (goalId) => api.get(`/goals/${goalId}/todos`),
  create: (goalId, data) => api.post(`/goals/${goalId}/todos`, data),
  update: (id, data) => api.put(`/todos/${id}`, data),
  updateStatus: (id, status) => api.patch(`/todos/${id}/status`, { status }),
  reorder: (todoIds) => api.patch('/todos/reorder', { todoIds }),
  delete: (id) => api.delete(`/todos/${id}`),
};

// Daily Todos API
export const dailyTodosApi = {
  getAll: () => api.get('/daily-todos'),
  getToday: () => api.get('/daily-todos/today'),
  create: (data) => api.post('/daily-todos', data),
  createBatch: (todos) => api.post('/daily-todos/batch', { todos }),
  update: (id, data) => api.put(`/daily-todos/${id}`, data),
  delete: (id) => api.delete(`/daily-todos/${id}`),
  complete: (id) => api.post(`/daily-todos/${id}/complete`),
  uncomplete: (id) => api.delete(`/daily-todos/${id}/complete`),
  completeForDate: (id, date) => api.post(`/daily-todos/${id}/complete-for-date`, { date }),
  importFromGoal: (goalId, todoIds) => api.post('/daily-todos/import-from-goal', { goal_id: goalId, todo_ids: todoIds }),
  getHistory: (days = 'all') => api.get('/daily-todos/history', { params: { days, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone } }),
  getIncomplete: () => api.get('/daily-todos/incomplete'),
  generateSubtasks: (title, goal, estimatedTime) => api.post('/daily-todos/generate-subtasks', { title, goal, estimatedTime }),
};

// Check-ins API
export const checkinsApi = {
  getAll: (year, month) => api.get('/checkins', { params: { year, month } }),
  getToday: () => api.get('/checkins/today'),
  getStreak: () => api.get('/checkins/streak'),
  create: (data) => api.post('/checkins', data),
  delete: (date) => api.delete(`/checkins/${date}`),
};

// Stats API
export const statsApi = {
  get: () => api.get('/stats'),
};

// Writings API
export const writingsApi = {
  getAll: () => api.get('/writings'),
  getById: (id) => api.get(`/writings/${id}`),
  create: (data) => api.post('/writings', data),
  update: (id, data) => api.put(`/writings/${id}`, data),
  delete: (id) => api.delete(`/writings/${id}`),
  translate: (content) => api.post('/writings/translate', { content }),
  splitThread: (content) => api.post('/writings/split-thread', { content }),
};

export default api;
